import { Component, Input } from '@angular/core';
 
@Component({
    selector: 'image',
    template: `<img [defaultImage]="defaultImage" [lazyLoad]="image" /> `,
    standalone: false
})

export class ImageComponent {

    @Input('image') image:ImageBitmap;

    defaultImage = 'assets/image/no-image-icon.png';
  
}